const OPEN_DURATION   = 200;
const FLIGHT_DURATION = 250;
const EASING          = 'cubic-bezier(0.4, 0, 0.2, 1)';
const PICKER_LIST     = '.bundle-available-products';
const BUNDLED_LIST    = '.bundle-product-rows';

let pendingFlight = null;

document.addEventListener('sortabledroptarget', event => {
    if (event.target.closest('.bundle-products')) {
        event.target.dispatchEvent(new CustomEvent('bundledrop'));
    }
});

function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function rowSnapshot(row) {
    const table = document.createElement('table');
    const body  = document.createElement('tbody');
    const clone = row.cloneNode(true);

    table.className = row.closest('table')?.className ?? '';
    body.className  = row.parentElement?.className ?? '';

    Array.from(row.children).forEach((cell, index) => {
        clone.children[index].style.width = `${cell.getBoundingClientRect().width}px`;
    });

    body.append(clone);
    table.append(body);

    return table;
}

function flightFromTrigger(element) {
    const pickerRow = element.closest('.picker-row');

    if (pickerRow) {
        return {productId: pickerRow.dataset.productId, destination: BUNDLED_LIST};
    }

    const removeButton = element.closest('.remove-bundle-item');

    if (removeButton) {
        return {productId: removeButton.closest('tr').dataset.productId, destination: PICKER_LIST};
    }

    return null;
}

function returnToTopOfPicker(table, productId, hideUntilLanded) {
    const picker = table.querySelector(PICKER_LIST);
    const row    = picker?.querySelector(`.picker-row[data-product-id="${productId}"]`);

    if (!row) {
        return;
    }

    row.classList.remove('added');
    row.classList.toggle('is-arriving', hideUntilLanded);
    picker.prepend(row);
}

export function rememberBundleItemFlight(event) {
    pendingFlight = null;

    const flight = flightFromTrigger(event.detail.elt);

    if (flight === null) {
        return;
    }

    const table = event.detail.elt.closest('.bundle-products');
    const row   = event.detail.elt.closest('tr');

    if (table === null || row === null) {
        return;
    }

    document.getElementById('bundle-form')?.dispatchEvent(new CustomEvent('form:touch'));

    const dropped  = event.detail.requestConfig?.triggeringEvent?.type === 'bundledrop';
    const animates = !prefersReducedMotion() && !dropped;

    if (flight.destination === PICKER_LIST) {
        returnToTopOfPicker(table, flight.productId, animates);
    }

    if (!animates) {
        return;
    }

    pendingFlight = {...flight, table, origin: row.getBoundingClientRect(), snapshot: rowSnapshot(row)};
}

export function flyBundleItem() {
    const flight = pendingFlight;

    pendingFlight = null;

    if (flight === null) {
        return;
    }

    const selector    = `${flight.destination} tr[data-product-id="${flight.productId}"]`;
    const destination = flight.table.querySelector(selector);

    if (destination === null) {
        return;
    }

    const ghost = document.createElement('div');

    ghost.className    = 'bundle-item-ghost';
    ghost.style.top    = `${flight.origin.top}px`;
    ghost.style.left   = `${flight.origin.left}px`;
    ghost.style.width  = `${flight.origin.width}px`;
    ghost.style.height = `${flight.origin.height}px`;

    ghost.append(flight.snapshot);
    document.body.append(ghost);

    destination.classList.add('is-arriving');

    const space = spaceBefore(destination, flight.table);

    openSpace(space, flight.origin.height)
        .then(() => {
            const target = space.getBoundingClientRect();

            return ghost.animate(
                [
                    {transform: 'translate(0, 0)'},
                    {transform: `translate(${target.left - flight.origin.left}px, ${target.top - flight.origin.top}px)`},
                ],
                {duration: FLIGHT_DURATION, easing: EASING},
            ).finished;
        })
        .then(() => settleFlight(ghost, space, destination, true), () => settleFlight(ghost, space, destination, false))
    ;
}

function spaceBefore(row, table) {
    const space = document.createElement('tr');
    const cell  = document.createElement('td');

    space.className = 'bundle-item-space';
    cell.colSpan    = table.tHead.rows[0].cells.length;

    space.append(cell);
    row.before(space);

    return space;
}

function openSpace(space, height) {
    return space.firstElementChild.animate(
        [{height: '0px'}, {height: `${height}px`}],
        {duration: OPEN_DURATION, easing: EASING, fill: 'forwards'},
    ).finished;
}

function settleFlight(ghost, space, destination, landed) {
    ghost.remove();
    space.remove();
    destination.classList.remove('is-arriving');

    if (!landed) {
        return;
    }

    destination.classList.add('has-landed');
    destination.addEventListener(
        'animationend',
        () => destination.classList.remove('has-landed'),
        {once: true},
    );
}
